import { ToastProvider } from './../../providers/toast';
import { LoadingProvider } from './../../providers/loading';
import { LoginPage } from './../login/login';
import { DeveloperProvider } from './../../providers/developers';
import { Validators, FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { CustomValidators } from "../../utils/validators";
import { CustomErrorHandler } from "@questrade/flx-commons";

@Component({
  selector: 'page-permission-request',
  templateUrl: 'permission-request.html',
})
export class PermissionRequestPage {
  userForm: FormGroup;
  private isAdmin: boolean = false;
  isRequestProcessed: boolean = false;
  trust_urls: string[] = [];

  constructor(
    public navCtrl: NavController,
    private navParams: NavParams,
    private fb: FormBuilder,
    private devProvider: DeveloperProvider,
    private loading: LoadingProvider,
    private toast: ToastProvider,
    private customErrorHandler: CustomErrorHandler) {
    this.isAdmin = this.navParams.get("isAdmin");
    this.createForm();
  }

  createForm() {
    this.userForm = this.fb.group({
      email: new FormControl('', [Validators.required, CustomValidators.emailValidator, CustomValidators.trimValidator]),
      username: new FormControl('', [Validators.required, CustomValidators.trimValidator]),
      password: new FormControl('', [Validators.required, CustomValidators.trimValidator]),
      first_name: new FormControl('', [Validators.required, CustomValidators.trimValidator]),
      last_name: new FormControl('', [Validators.required, CustomValidators.trimValidator]),
      merchant: new FormControl('', [Validators.required, CustomValidators.trimValidator]),
    });

    if (this.isAdmin) {
      this.userForm.addControl('merchant_username', new FormControl('', [Validators.required, CustomValidators.trimValidator]));
      this.userForm.addControl('merchant_password', new FormControl('', [Validators.required, CustomValidators.trimValidator]));
      this.userForm.addControl('trust_url', new FormControl('', [CustomValidators.urlValidator]));
      this.userForm.addControl('client_id', new FormControl('', [Validators.required, CustomValidators.trimValidator]));
      this.userForm.addControl('notification_uri', new FormControl('', [CustomValidators.urlValidator]));
      this.userForm.addControl('redirection_success_uri', new FormControl('', [CustomValidators.urlValidator]));
      this.userForm.addControl('redirection_error_uri', new FormControl('', [CustomValidators.urlValidator]));
      this.userForm.addControl('default_requested_amount', new FormControl('', [Validators.required, CustomValidators.numberValidator]));
      this.userForm.addControl('role', new FormControl('ONLINE'));
    }
  }

  submit() {
    this.checkControls();
    if (!this.userForm.valid) return;
    if (this.isAdmin) {
      // Add status 'Pending' by default on the creation of the user
      this.userForm.value.status = 'Pending'
    }
    let loadingInstance = this.loading.create();
    const userData = { ...this.userForm.value, trust_url: this.trust_urls };
    this.devProvider.permissionRequest(userData)
      .subscribe(
        data => {
          loadingInstance.dismiss();
          this.isRequestProcessed = true;
        },
        error => {
          loadingInstance.dismiss();
          this.toast.create(error.json().error, 'error');
        });
  }

  goToLogin() {
    this.navCtrl.setRoot(LoginPage);
  }

  goBack() {
    if (this.isAdmin) {
      this.navCtrl.pop();
    } else {
      this.navCtrl.setRoot(LoginPage);
    }
  }

  handleAddTrustUrl() {
    const newTrustUrl = this.userForm.controls['trust_url'].value;
    if (newTrustUrl && this.userForm.controls['trust_url'].valid && this.trust_urls.indexOf(newTrustUrl) == -1) {
      this.trust_urls.push(newTrustUrl);
      this.userForm.controls['trust_url'].setValue("");
    }
  }

  handleRemoveTrustUrl(index) {
    this.trust_urls.splice(index, 1);
  }

  checkControls() {
    Object.keys(this.userForm.controls).forEach(key => {
      if (!this.userForm.controls[key].valid && !this.userForm.controls[key].disabled) {
        this.userForm.get(key).markAsTouched();
        this.userForm.get(key).markAsDirty();
        this.userForm.get(key).updateValueAndValidity();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/permission-request/permission-request.ts